import React from "react";
import { Col, Container, Row, Image } from 'react-bootstrap';
import 'react-phone-input-2/lib/style.css';
import LazyLoad from 'react-lazy-load'
import ContactUsForm from "./contact-us-form";

import Imag1 from '../images/fintech-digital-payments-in-nigeria-founded.svg';
import Imag2 from '../images/fintech-digital-payments-in-nigeria-expert.svg';
import Imag3 from '../images/fintech-digital-payments-in-nigeria-customer.svg';
import Imag4 from '../images/fintech-digital-payments-in-nigeria-country.svg';
import Imag5 from '../images/fintech-digital-payments-in-nigeria-partnership.svg';
import Imag6 from '../images/fintech-digital-payments-in-nigeria-platform.svg';

// const { useFormik } = React.lazy(() => import('formik'))
// const PhoneInput = React.lazy(() => import('react-phone-input-2'))
// const { object, string } = React.lazy(() => import('yup'))

const RequestQuote = () => {

    return (
        <>
            <section className="footer-form-section section">
                <Container className="py-5">
                    <Row className="justify-content-between align-items-center g-5">
                        <Col lg={6}>
                            <div className="section-title">
                                <h2 className="heading text-white mb-5 fw-semibold h2 font-size-50">Let's Talk! Have Questions? We’re Here to Help....</h2>
                                <p className="text-white opacity-85 lead mb-4 pb-4">Fill all your details in the form and one of our business consultant will get in touch you within 24 hours.</p>
                                <Row className="g-4" xs={2}>
                                    <Col lg={4}>
                                        <div className="icon-size-50 mb-2">
                                            <Image loading="lazy" className="lazyload" src={Imag1} width={42} height={42} alt="logo" />
                                        </div>
                                        <h3 className="text-white font-size-24">2019 </h3>
                                        <p className="text-white opacity-85">Founded in</p>
                                    </Col>
                                    <Col lg={4}>
                                        <div className="icon-size-50 mb-2">
                                            <Image loading="lazy" className="lazyload" src={Imag2} width={50} height={32} alt="logo" />
                                        </div>
                                        <h3 className="text-white font-size-24">120+ </h3>
                                        <p className="text-white opacity-85">In-house Tech experts</p>
                                    </Col>
                                    <Col lg={4}>
                                        <div className="icon-size-50 mb-2">
                                            <Image loading="lazy" className="lazyload" src={Imag4} width={46} height={44} alt="logo" />
                                        </div>
                                        <h3 className="text-white font-size-24">15+ </h3>
                                        <p className="text-white opacity-85">Country served</p>
                                    </Col>
                                    <Col lg={4}>
                                        <div className="icon-size-50 mb-2">
                                            <Image loading="lazy" className="lazyload" src={Imag3} width={46} height={32} alt="logo" />
                                        </div>
                                        <h3 className="text-white font-size-24">100k+ </h3>
                                        <p className="text-white opacity-85">Customers Achieved by our clients</p>
                                    </Col>
                                    <Col lg={4}>
                                        <div className="icon-size-50 mb-2">
                                            <Image loading="lazy" className="lazyload" src={Imag5} width={49} height={44} alt="logo" />
                                        </div>
                                        <h3 className="text-white font-size-24">10+ </h3>
                                        <p className="text-white opacity-85">Paytech leader partnerships</p>
                                    </Col>
                                    <Col lg={4}>
                                        <div className="icon-size-50 mb-2">
                                            <Image loading="lazy" className="lazyload" src={Imag6} width={37} height={37} alt="logo" />
                                        </div>
                                        <h3 className="text-white font-size-24">8+ </h3>
                                        <p className="text-white opacity-85">Fintech Platforms Introduced</p>
                                    </Col>
                                </Row>

                            </div>
                        </Col>
                        <Col lg={6}>
                            {/* <h2 className="heading text-white mb-4-lg fw-semibold">Get a live demo</h2> */}
                            <LazyLoad offset={300}>
                                <ContactUsForm />
                            </LazyLoad>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default RequestQuote
